document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.custom-map');
  if (!sections.length) return;

  const lastTriggerBySection = new WeakMap();
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const htmlEl = document.documentElement;

  const centerMobileMap = (sectionEl) => {
    if (!mobileQuery.matches || !sectionEl) return;
    if (sectionEl.getAttribute('data-center-mobile') !== 'true') return;
    const maxScroll = sectionEl.scrollWidth - sectionEl.clientWidth;
    if (maxScroll <= 1) return;
    sectionEl.scrollLeft = maxScroll / 2;
  };
  const originalHtmlOverflow = htmlEl.style.overflow;
  let scrollLockCount = 0;

  const setMobileScrollLock = (locked) => {
    if (!mobileQuery.matches) return;

    if (locked) {
      scrollLockCount += 1;
      if (scrollLockCount === 1) {
        htmlEl.style.overflow = 'hidden';
      }
      return;
    }

    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      htmlEl.style.overflow = originalHtmlOverflow;
    }
  };

  const ensureSlickForCardBox = (cardBoxEl, locationId) => {
    if (!cardBoxEl || !locationId) return;
    if (!window.jQuery) return;

    const $cardBox = jQuery(cardBoxEl);
    const $list = $cardBox.find('.map-card-list').first();
    if (!$list.length) return;

    const refreshIfInited = () => {
      if (!$list.hasClass('slick-initialized')) return false;
      $list.slick('setPosition');
      return true;
    };

    if (refreshIfInited()) return;

    let attempts = 0;
    const tick = () => {
      attempts += 1;

      if (refreshIfInited()) return;
      if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
        if (attempts < 30) setTimeout(tick, 100);
        return;
      }

      const $prev = $cardBox.find(`.map-card-prev-${CSS.escape(locationId)}`).first();
      const $next = $cardBox.find(`.map-card-next-${CSS.escape(locationId)}`).first();
      const $dotsBox = $cardBox.find(`.map-card-dots-${CSS.escape(locationId)}`).first();

      $list.off('init.customMapSlick').on('init.customMapSlick', (event, slick) => {
        const $slider = slick.$slider;
        const $dots = $slider && $slider.find('.slick-dots');
        if ($dots && $dots.find('li').length <= 1) $dots.remove();
      });

      $list.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        adaptiveHeight: true,
        draggable: true,
        prevArrow: $prev.length ? $prev : undefined,
        nextArrow: $next.length ? $next : undefined,
        appendDots: $dotsBox.length ? $dotsBox : undefined,
      });
    };
    tick();
  };

  const setAttractDot = (sectionEl, targetDot) => {
    if (!sectionEl || !targetDot) return;
    sectionEl.querySelectorAll('.custom-map-dot.is-attract').forEach((dot) => {
      if (dot !== targetDot) dot.classList.remove('is-attract');
    });
    targetDot.classList.add('is-attract');
    sectionEl.querySelectorAll('.custom-map-dot.is-attract-paused').forEach((dot) => {
      dot.classList.remove('is-attract-paused');
    });
  };

  const pauseAttractExcept = (sectionEl, hoveredDot) => {
    sectionEl.querySelectorAll('.custom-map-dot.is-attract').forEach((dot) => {
      dot.classList.toggle('is-attract-paused', Boolean(hoveredDot) && dot !== hoveredDot);
    });
  };

  const getActiveCard = (sectionEl) => {
    if (!sectionEl) return null;
    const activeGroup = sectionEl.querySelector('.map-card-group.active');
    if (activeGroup) {
      const fromGroup = activeGroup.querySelector('.map-card-box');
      if (fromGroup) return fromGroup;
    }
    return Array.from(sectionEl.querySelectorAll('.map-card-box')).find((card) => {
      return card.style.display === 'block';
    }) || null;
  };

  const closeCard = (sectionEl, cardBoxEl, options = {}) => {
    if (!sectionEl || !cardBoxEl) return;
    const { restoreFocus = true } = options;
    const locationId = cardBoxEl.getAttribute('data-id');

    if (cardBoxEl.__customMapTrapHandler) {
      cardBoxEl.removeEventListener('keydown', cardBoxEl.__customMapTrapHandler);
      cardBoxEl.__customMapTrapHandler = null;
    }

    cardBoxEl.style.display = 'none';
    cardBoxEl.closest('.map-card-group')?.classList.remove('active');
    setMobileScrollLock(false);
    if (locationId) {
      const dot = sectionEl.querySelector(`.custom-map-dot[data-id="${CSS.escape(locationId)}"]`);
      if (dot) dot.classList.remove('is-active');
    }

    if (!restoreFocus) return;
    const trigger = lastTriggerBySection.get(sectionEl);
    if (trigger && typeof trigger.focus === 'function') trigger.focus();
  };

  const closeActiveCard = (sectionEl, options = {}) => {
    const activeCard = getActiveCard(sectionEl);
    if (!activeCard) return false;
    closeCard(sectionEl, activeCard, options);
    return true;
  };

  const showCardById = (sectionEl, locationId) => {
    const activeCard = getActiveCard(sectionEl);
    if (activeCard) {
      const activeId = activeCard.getAttribute('data-id');
      // Same pin: keep the current popup open.
      if (locationId && activeId === locationId) return;
      // Different pin (or empty id): close the active popup first.
      closeCard(sectionEl, activeCard, { restoreFocus: false });
    }

    if (!locationId) return;

    const dots = Array.from(sectionEl.querySelectorAll('.custom-map-dot'));
    const cardGroups = Array.from(sectionEl.querySelectorAll('.map-card-group'));
    const cards = Array.from(sectionEl.querySelectorAll('.map-card-box'));
    if (!dots.length || !cards.length) return;

    const targetDot = sectionEl.querySelector(`.custom-map-dot[data-id="${CSS.escape(locationId)}"]`);
    const targetCard = sectionEl.querySelector(`.map-card-box[data-id="${CSS.escape(locationId)}"]`);
    if (!targetDot || !targetCard) return;

    dots.forEach((d) => d.classList.remove('is-active'));
    targetDot.classList.add('is-active');

    cards.forEach((c) => {
      c.style.display = 'none';
    });
    targetCard.style.display = 'block';

    const targetCardGroup = targetCard.closest('.map-card-group');
    cardGroups.forEach((cg) => {
      cg.classList.remove('active');
    });
    targetCardGroup?.classList.add('active');
    setMobileScrollLock(true);

    ensureSlickForCardBox(targetCard, locationId);

    targetCard.setAttribute('role', 'dialog');
    targetCard.setAttribute('aria-modal', 'true');
    targetCard.setAttribute('tabindex', '-1');

    const firstFocusableElement = targetCard.querySelector('.first-focusable-element');
    const lastFocusableElement = targetCard.querySelector('.last-focusable-element');

    if (targetCard.__customMapTrapHandler) {
      targetCard.removeEventListener('keydown', targetCard.__customMapTrapHandler);
      targetCard.__customMapTrapHandler = null;
    }

    if (firstFocusableElement && lastFocusableElement) {
      const handler = function (e) {
        if (e.key !== 'Tab') return;
        if (e.target === firstFocusableElement && e.shiftKey) {
          e.preventDefault();
          lastFocusableElement.focus();
        } else if (e.target === lastFocusableElement && !e.shiftKey) {
          e.preventDefault();
          firstFocusableElement.focus();
        }
      };
      targetCard.__customMapTrapHandler = handler;
      targetCard.addEventListener('keydown', handler);
    }

    const closeBtn = targetCard.querySelector('.map-card-close');
    if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
  };

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    for (const sectionEl of sections) {
      if (!closeActiveCard(sectionEl)) continue;
      e.preventDefault();
      break;
    }
  });

  const onMobileChange = () => {
    if (!mobileQuery.matches) return;
    sections.forEach((sectionEl) => centerMobileMap(sectionEl));
  };
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', onMobileChange);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(onMobileChange);
  }

  sections.forEach((sectionEl) => {
    centerMobileMap(sectionEl);
    requestAnimationFrame(() => centerMobileMap(sectionEl));

    const inner = sectionEl.querySelector('.custom-map-inner') || sectionEl;

    inner.addEventListener('click', (e) => {
      const closeBtn = e.target && e.target.closest ? e.target.closest('.map-card-close') : null;
      if (closeBtn && inner.contains(closeBtn)) {
        e.preventDefault();
        e.stopPropagation();
        const cardBox = closeBtn.closest('.map-card-box');
        if (cardBox) closeCard(sectionEl, cardBox);
        return;
      }

      const dot = e.target && e.target.closest ? e.target.closest('.custom-map-dot') : null;
      if (!dot || !inner.contains(dot)) return;
      const locationId = (dot.getAttribute('data-id') || '').trim();
      lastTriggerBySection.set(sectionEl, dot);
      setAttractDot(sectionEl, dot);
      // Always go through showCardById: closes the active popup first,
      // then opens the matching card when this pin has a valid location id.
      showCardById(sectionEl, locationId);
    });

    // 初始化时显示第一个卡片
    // const activeDot = sectionEl.querySelector('.custom-map-dot.is-active') || sectionEl.querySelector('.custom-map-dot');
    // if (activeDot) {
    //   const locationId = activeDot.getAttribute('data-id');
    //   showCardById(sectionEl, locationId);
    // }
    const attractDots = sectionEl.querySelectorAll('.custom-map-dot.is-attract');
    if (attractDots.length > 1) {
      setAttractDot(sectionEl, attractDots[attractDots.length - 1]);
    }

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      inner.addEventListener('mouseenter', (e) => {
        const dot = e.target && e.target.closest ? e.target.closest('.custom-map-dot') : null;
        if (!dot || !inner.contains(dot)) return;
        pauseAttractExcept(sectionEl, dot);
      }, true);

      inner.addEventListener('mouseleave', (e) => {
        const dot = e.target && e.target.closest ? e.target.closest('.custom-map-dot') : null;
        if (!dot || !inner.contains(dot)) return;
        const next = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.custom-map-dot') : null;
        if (next && inner.contains(next)) return;
        pauseAttractExcept(sectionEl, null);
      }, true);
    }
  });
});
